import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";
import LogosComponent from "@/components/LogosComponent.vue";
import StartupsComponent from "@/components/StartupsComponent.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/startups",
    name: "startups",
    component: StartupsComponent,
  },
  {
    path: "/logos",
    name: "logos",
    component: LogosComponent,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
